!(function () {
  "use strict";
  function e(e, t) {
    for (var n = 0; n < t.length; n++) {
      var i = t[n];
      (i.enumerable = i.enumerable || !1),
        (i.configurable = !0),
        "value" in i && (i.writable = !0),
        Object.defineProperty(e, i.key, i);
    }
  }
    new ((function () {
      function t() {
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          (this.container = document.querySelector(".countdown-container")),
          (this.endTime = new Date(
            this.container.dataset.endTime.replace(/-/g, '/')
          ).getTime()),
          // (this.endTime = new Date("2023/11/20 12:00:00+08:00").getTime()),
          (this.timer = null),
          (this.distance = null),
          (this.daysEle = document.querySelector(".z-days")),
          (this.hoursEle = document.querySelector(".z-hours")),
          (this.minutesEle = document.querySelector(".z-minutes")),
          (this.secondsEle = document.querySelector(".z-seconds")),
          (this.$ = {
            days: document.querySelector(".days-1"),
            hours: document.querySelector(".hours-1"),
            minutes: document.querySelector(".min-1"),
            seconds: document.querySelector(".sec-1"),
          });
        this.init();
      }
      var n, i, o;
      return (
        (n = t),
        (i = [
          {
            key: "init",
            value: function () {
              var e = this;
              this.updateCountdown(),
                (this.timer = setInterval(function () {
                  e.updateCountdown();
                }, 1e3));
            },
          },
          {
            key: "updateCountdown",
            value: function () {
              var e = new Date().getTime();
              (this.distance = this.endTime - e), this.start();
            },
          },
          {
            key: "start",
            value: function () {
              var e = this;
              this.updateCounter(),
                (this.timer = setInterval(function () {
                  e.updateCounter();
                }, 1e3));
            },
          },
          {
            key: "stop",
            value: function () {
              clearInterval(this.timer), (this.timer = null);
            },
          },
          {
            key: "updateCounter",
            value: function () {
              var e = this.distance;
              if (e <= 0)
                return (
                  this.stop(), void (this.container.style.display = "none")
                );
              var that = this,
                $days_1 = this.$.days,
                $hour_1 = this.$.hours,
                $min_1 = this.$.minutes,
                $sec_1 = this.$.seconds;
              var days = Math.floor(e / 864e5),
                hours = Math.floor((e % 864e5) / 36e5),
                minutes = Math.floor((e % 36e5) / 6e4),
                seconds = Math.floor((e % 6e4) / 1e3);
              this.checkHour(days, $days_1);
              // Hours
              this.checkHour(hours, $hour_1);
              // Minutes
              this.checkHour(minutes, $min_1);
              // Seconds
              this.checkHour(seconds, $sec_1);
              var days = Math.floor(e / 864e5),
                hours = Math.floor((e % 864e5) / 36e5),
                minutes = Math.floor((e % 36e5) / 6e4),
                seconds = Math.floor((e % 6e4) / 1e3);
              // (this.daysEle.innerHTML = days < 10 ? "0" + t : t),
              //   (this.hoursEle.innerHTML = hours < 10 ? "0" + n : n),
              //   (this.minutesEle.innerHTML = minutes < 10 ? "0" + i : i),
              //   (this.secondsEle.innerHTML = seconds < 10 ? "0" + o : o);
            },
          },
          {
            key: "checkHour",
            value: function (value, $el_1) {
              value = value.toString();
              var fig_1_value = $el_1.querySelector(".top").innerText;
              value = value < 10 ? "0" + value : value;
              if (fig_1_value !== value) this.animateFigure($el_1, value);
            },
          },
          {
            key: "animateFigure",
            value: function ($el, value) {
              var that = this,
                $top = $el.querySelector(".top"),
                $bottom = $el.querySelector(".bottom"),
                $back_top = $el.querySelector(".top-back"),
                $back_bottom = $el.querySelector(".bottom-back");
              // Before we begin, change the back value
              $back_top.querySelector("span").innerHTML = value;

              // Also change the back bottom value
              $back_bottom.querySelector("span").innerHTML = value;

              // Then animate
              TweenMax.to($top, 0.8, {
                rotationX: "-180deg",
                transformPerspective: 300,
                ease: Quart.easeOut,
                onComplete: function () {
                  $top.innerHTML = value;
                  $bottom.innerHTML = value;
                  TweenMax.set($top, { rotationX: 0 });
                },
              });

              TweenMax.to($back_top, 0.8, {
                rotationX: 0,
                transformPerspective: 300,
                ease: Quart.easeOut,
                clearProps: "all",
              });
            },
          },
        ]) && e(n.prototype, i),
        o && e(n, o),
        Object.defineProperty(n, "prototype", { writable: !1 }),
        t
      );
    })())();
})();
